import { defineMessages, type MessageValue } from 'react-intl';

export const upsellProductMessages = defineMessages<{
  readonly oneClickA11yLabel: { readonly product_name: MessageValue };
}>({
  oneClickA11yLabel: {
    defaultMessage: 'Add 1 {product_name} to your bag',
    description: 'Upsell Product | One-click add to bag a11y label',
  },
});
